"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var FILTER_GROUP_DEFAULT = "FILTER_GROUP_DEFAULT";
var FILTER_GROUP_ACTIVE = "FILTER_GROUP_ACTIVE";
var FILTER_ITEM_DEFAULT = "FILTER_ITEM_DEFAULT";
var FILTER_ITEM_ACTIVE = "FILTER_ITEM_ACTIVE";
var FILTER_ITEM_DISABLED = "FILTER_ITEM_DISABLED";
var FILTER_ITEM_OPTION_DEFAULT = "FILTER_ITEM_OPTION_DEFAULT";
var FILTER_ITEM_OPTION_ACTIVE = "FILTER_ITEM_OPTION_ACTIVE";
var FILTER_ITEM_OPTION_DISABLED = "FILTER_ITEM_OPTION_DISABLED";
var FOLDER_ITEM_DEFAULT = "FOLDER_ITEM_DEFAULT";
var FOLDER_ITEM_ACTIVE = "FOLDER_ITEM_ACTIVE";
var FOLDER_ITEM_DISABLED = "FOLDER_ITEM_DISABLED";
var USER_ITEM_DEFAULT = "USER_ITEM_DEFAULT";
var USER_ITEM_ACTIVE = "USER_ITEM_ACTIVE";
var USER_ITEM_DISABLED = "USER_ITEM_DISABLED";
var _default = {
  FILTER_GROUP_DEFAULT: FILTER_GROUP_DEFAULT,
  FILTER_GROUP_ACTIVE: FILTER_GROUP_ACTIVE,
  FILTER_ITEM_DEFAULT: FILTER_ITEM_DEFAULT,
  FILTER_ITEM_ACTIVE: FILTER_ITEM_ACTIVE,
  FILTER_ITEM_DISABLED: FILTER_ITEM_DISABLED,
  FILTER_ITEM_OPTION_DEFAULT: FILTER_ITEM_OPTION_DEFAULT,
  FILTER_ITEM_OPTION_ACTIVE: FILTER_ITEM_OPTION_ACTIVE,
  FILTER_ITEM_OPTION_DISABLED: FILTER_ITEM_OPTION_DISABLED,
  FOLDER_ITEM_DEFAULT: FOLDER_ITEM_DEFAULT,
  FOLDER_ITEM_ACTIVE: FOLDER_ITEM_ACTIVE,
  FOLDER_ITEM_DISABLED: FOLDER_ITEM_DISABLED,
  USER_ITEM_DEFAULT: USER_ITEM_DEFAULT,
  USER_ITEM_ACTIVE: USER_ITEM_ACTIVE,
  USER_ITEM_DISABLED: USER_ITEM_DISABLED
};
exports.default = _default;